import SettingPage from '@/pages/settings/CMSettingPage.vue'
import ApplicationSettingPage from '@/pages/settings/CMApplicationSettingsPage.vue'
import EntitiesSettings from "@/pages/routing/EntitiesSettings.vue";
import EntitiesSettingsTB from "@/pages/routing/EntitiesSettingsTB.vue";

export default [
  {
    path: '/settings/',
    component: SettingPage
  },
  {
    path: '/settings/application/',
    component: ApplicationSettingPage
  },
  {
    path: '/entitiessettings/:type/:ConfigurationType',
    component: EntitiesSettings
  },
  {
    path: '/entitiessettingsTB/',
    component: EntitiesSettingsTB
  }
]
